export default __webpack_public_path__ + "static/media/favicon.4ee315a6.png";